/** @format */
import { Transition } from '@uirouter/core';
import { LogoutPageComponent, NoSisuAccountPageComponent, SisStateDeclaration, StudentLoginPageComponent } from 'sis-components';
import { studentRoutes } from './student-routes';

export const loginStates: SisStateDeclaration[] = [
    {
        name: 'student.logout',
        url: '/logout',
        data: {
            hideHeader: true,
        },
        headerParams: {
            skipBreadcrumb: true,
        },
        component: LogoutPageComponent,
    },
    {
        name: studentRoutes.noSisuAccount,
        url: '/no-sisu-account?reason',
        data: {
            hideHeader: true,
        },
        headerParams: {
            skipBreadcrumb: true,
        },
        component: NoSisuAccountPageComponent,
    },
    {
        name: 'student.login',
        url: '/login?target&loggedOut',
        data: {
            hideHeader: true,
        },
        headerParams: {
            skipBreadcrumb: true,
            displayNameKey: 'NAVIGATION.LOGIN',
        },
        component: StudentLoginPageComponent,
        resolve: {
            loginTarget: getLoginTarget,
            continueWithoutLogin: getAnonymousLoginState,
        },
    },
];

function getLoginTarget($transition$: Transition) {
    const storedLoginTarget = sessionStorage.getItem('loginTarget');
    return (
        $transition$.options().custom.customTargetPath ??
        $transition$.options().custom.loginTarget ??
        storedLoginTarget ??
        window.location.href
    );
}

getLoginTarget.$inject = ['$transition$'];

function getAnonymousLoginState() {
    return studentRoutes.continueWithoutLogin;
}

getAnonymousLoginState.$inject = ['$transition$'];
